import { ProfileImg } from "./profile-pic-component.styles";

const ProfilePic = () => {
  return (
    <>
      <ProfileImg
        src="/assets/images/sh.png"
        alt="profile"
        className={`profile-img`}
      />
    </>
  );
};
export default ProfilePic;
